<template>
  <detailTemplate :classCustom="'detail-docs extend-detail'">
    <template #content>
      <div class="back-icon border-radius__50 clickable flex-row flex__center" @click="backListPage()">
        <i class="el-icon-back font-size__large"></i>
      </div>

      <!--content-->
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div class="font-size__large font-weight__bold margin-bottom-10" style="color: #007aff">
            CHI TIẾT VĂN BẢN
          </div>

          <!--THÔNG TIN YÊU CẦU & THÔNG TIN PHÒNG HỌP-->
          <div class="form-info padding-right-10 padding-bottom-10">
            <el-form inline-message>
              <div class="group__info margin-top-10 padding-bottom-10">
                <div class="content">
                  <div class="form-input">
                    <div class="title font-size__medium font-weight__bold margin-bottom-10 margin-top-10">THÔNG TIN VĂN
                      BẢN
                    </div>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Nguồn văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docOriginal"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Loại văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docTypeName"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Trích yếu:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.brief"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Đối tượng trình:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.approverTypeName"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Văn bản khẩn</span>
                      <el-checkbox v-model="hcCaseDoc.isUrgent"></el-checkbox>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Văn bản mật</span>
                      <el-checkbox v-model="hcCaseDoc.isSecurity"></el-checkbox>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Cơ quan ban hành:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.agencyIssued"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Số văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                @blur="hcCaseDoc.docNum = hcCaseDoc.docNum.trim()"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docNum"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Số ký hiệu văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                @blur="hcCaseDoc.docSign = hcCaseDoc.docSign.trim()"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docSign"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Ngày văn bản:</span>
                      <el-date-picker
                        disabled
                        v-model="hcCaseDoc.docDate"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy"
                        value-format="timestamp"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Hạn xử lý văn bản:</span>
                      <el-date-picker
                        disabled
                        v-model="hcCaseDoc.timeDeadline"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy"
                        value-format="timestamp"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Ngày nhận:</span>
                      <el-date-picker
                        disabled
                        v-model="hcCaseDoc.receivedDate"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy HH:mm"
                        value-format="timestamp"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Ngày trả:</span>
                      <el-date-picker
                        disabled
                        v-model="hcCaseDoc.returnDate"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy HH:mm"
                        value-format="timestamp"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Ngày hủy:</span>
                      <el-date-picker
                        disabled
                        v-model="hcCaseDoc.cancelDate"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy HH:mm"
                        value-format="timestamp"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Ngày hoàn thành:</span>
                      <el-date-picker
                        disabled
                        v-model="hcCaseDoc.finishDate"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy HH:mm"
                        value-format="timestamp"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <div class="flex-row custom-label__input width25" v-if="attachment">
                      <span class="label-input">Tệp đính kèm</span>
                      <div class="file-uploaded custome-file_uploaded">
                        <div class="file clickable flex-row flex__between">
                          <a
                            v-openInNewTab
                            :href="getToken(attachment.id) | buildAttachmentURL({ type: DOWNLOAD_OPTION.TYPE.ORIGINAL })"
                            class="flex-row flex__left"
                          >
                            <fileTypeImage
                              :fileExtention="attachment.fileExtention"
                              :customClass="'icon-small margin-right-10'"
                            />
                            <span class="fileName font-weight_normal">Xem chi tiết tệp đính kèm</span>
                          </a>
                        </div>
                      </div>
                    </div>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Đơn vị trình:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.requestDeptName"
                      />
                    </el-form-item>

                    <div class="title font-size__medium font-weight__bold margin-bottom-10 margin-top-10">THÔNG TIN
                      CHUYỂN VĂN BẢN
                    </div>

                    <el-table
                      :data="hcCaseDocOrgs"
                      style="width: 100%"
                    >
                      <el-table-column
                        label="LÃNH ĐẠO CHUYỂN">
                        <template slot-scope="scope">
                          <div>
                            {{approverName(scope.row.approverId)}}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="ĐƠN VỊ NHẬN">
                        <template slot-scope="scope">
                          <div>
                            {{deptName(scope.row.returnDeptId)}}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="NỘI DUNG CHỈ ĐẠO">
                        <template slot-scope="scope">
                          <div>{{scope.row.directionContent}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="DEADLINE">
                        <template slot-scope="scope">
                          <div>{{formatDate(scope.row.deadline)}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        width="100"
                        label="BÁO CÁO">
                        <template slot-scope="scope">
                          <el-checkbox :disabled="true" v-model="scope.row.isNeedReportBoolean"></el-checkbox>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="NỘI DUNG BÁO CÁO">
                        <template slot-scope="scope">
                          <div>{{scope.row.processContent}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="NGÀY HOÀN THÀNH">
                        <template slot-scope="scope">
                          <div>
                            {{formatDate(scope.row.finishDate)}}
                          </div>
                        </template>
                      </el-table-column>

                    </el-table>

                    <br>
                    <br>

                    <el-table
                      :data="hcCaseDocTransferApprovers"
                      style="width: 100%"
                    >
                      <el-table-column
                        label="LÃNH ĐẠO CHUYỂN">
                        <template slot-scope="scope">
                          <div>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="scope.row.approverIdFrom"
                              filterable
                              placeholder="-"
                            >
                              <el-option
                                v-for="item in hcCaseDocApprovers"
                                :key="item.approverId"
                                :label="item.approverFullname + ' - ' + item.positionName"
                                :value="item.approverId"
                              ></el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="LÃNH ĐẠO NHẬN">
                        <template slot-scope="scope">
                          <div>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="scope.row.approverIdTo"
                              filterable
                              placeholder="-"
                            >
                              <el-option
                                v-for="item in leaders"
                                :key="item.id"
                                :label="item.fullName + ' - ' + item.positionName"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="NỘI DUNG CHUYỂN">
                        <template slot-scope="scope">
                          <div>
                            <el-input
                              class="input-border__bottom input-border__radius__0 input-font__bold inputDirection"
                              type="text" size="mini"
                              maxlength="1000"
                              v-model="scope.row.directionContent"
                            />
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="DEADLINE">
                        <template slot-scope="scope">
                          <div>
                            <el-date-picker
                              v-model="scope.row.deadline"
                              type="date"
                              placeholder="Pick a day"
                              format="dd/MM/yyyy"
                              value-format="timestamp"
                            >
                            </el-date-picker>
                          </div>
                        </template>
                      </el-table-column>

                    </el-table>

                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </VuePerfectScrollbar>
      <!--footer-->
      <div class="footer">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">

          </div>
        </div>
      </div>
    </template>
  </detailTemplate>
</template>

<script type="text/javascript">
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import handleRequestErrorMixin from "../../handleRequestErrorMixin";
    import hanhchinhService from "../../../services/hanhchinhService";
    // import { EventBus } from "../../../event-bus.js";
    import moment from "moment";
    import constants from "../../../constants";
    import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
    import buildAttachmentURL from "../../../filters/buildAttachmentURL.js";
    import uploadFileMixin from "../../doc-in/uploadFileMixin";
    import h from "../../../services/h";

    export default {
        name: "luongVb_Detail",
        mixins: [handleRequestErrorMixin, vbAttachmentTokenMixin, uploadFileMixin],
        filters: {buildAttachmentURL},
        data() {
            return {
                attachment: null,
                leaders: [],
                listDept: [],
                hcCaseDoc: {},
                hcCaseDocOrgs: [],
                hcCaseDocTransferApprovers: [],
                hcCaseDocApprovers: []
            }
        },

        components: {
            VuePerfectScrollbar,
            detailTemplate: () => import("../../common/detail.vue"),
            Multiselect: () => import("vue-multiselect"),
            VueCtkDateTimePicker: () => import ("vue-ctk-date-time-picker"),
            fileTypeImage: () => import("../../job/FileTypeImage.vue")
        },

        created() {
            this.getData();
            this.getListLd();
            this.getListDept();
        },

        computed: {
            caseMasterId() {
                return this.$route.params.id;
            },

            currentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.deptId;
            },

            parentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.parentDeptId;
            }
        },

        methods: {
            backListPage() {
                this.$router.push({
                    name: "vbLuongVanBan",
                    query: this.$route.query,
                    params: this.$route.params
                });
            },

            getData() {
                hanhchinhService.getDetailReturn(this.caseMasterId).then(res => {
                    this.hcCaseDoc = {
                        caseMasterId: res.data.hcCaseDoc.caseMasterId,
                        docOriginal: res.data.hcCaseDoc.docOriginal == 1 ? "Văn bản nội bộ" : "Văn bản ngoài",
                        docTypeName: res.data.hcCaseDoc.docTypeName,
                        docSign: res.data.hcCaseDoc.docSign,
                        docNum: res.data.hcCaseDoc.docNum,
                        docDate: res.data.hcCaseDoc.docDate,
                        requestDeptName: res.data.hcCaseDoc.requestDeptName,
                        agencyIssued: res.data.hcCaseDoc.agencyIssued,
                        isUrgent: res.data.hcCaseDoc.urgencyLevel == 1,
                        isSecurity: res.data.hcCaseDoc.securityLevel == 1,
                        timeDeadline: res.data.hcCaseDoc.timeDeadline,
                        brief: res.data.hcCaseDoc.brief,
                        approverTypeName: res.data.hcCaseDoc.approverType == 1 ? "Ban TGĐ" : "HĐTV",
                        receivedDate: res.data.hcCaseDoc.receivedDate,
                        returnDate: res.data.hcCaseDoc.returnDate,
                        cancelDate: res.data.hcCaseDoc.cancelDate,
                        finishDate: res.data.hcCaseDoc.finishDate
                    };

                    this.attachment = res.data.attachments.length > 0 ? res.data.attachments[0] : null;

                    this.hcCaseDocOrgs = [];
                    for (let i = 0; i < res.data.hcCaseDocOrgs.length; i++) {
                        let hcCaseDocOrg = res.data.hcCaseDocOrgs[i];
                        this.hcCaseDocOrgs.push({
                            deadline: hcCaseDocOrg.deadline,
                            isNeedReportBoolean: hcCaseDocOrg.isNeedReport == 1,
                            approverId: hcCaseDocOrg.approverId,
                            approverFullname: hcCaseDocOrg.approverFullname,
                            returnDeptName: hcCaseDocOrg.returnDeptName,
                            returnDeptId: hcCaseDocOrg.returnDeptId,
                            directionContent: hcCaseDocOrg.directionContent,
                            processContent: hcCaseDocOrg.processContent,
                            finishDate: hcCaseDocOrg.finishDate,
                            isNew: false
                        });
                    }

                    this.hcCaseDocTransferApprovers = [];
                    for (let i = 0; i < res.data.hcCaseDocTransferApprovers.length; i++) {
                        this.hcCaseDocTransferApprovers.push({
                            deadline: res.data.hcCaseDocTransferApprovers[i].deadline,
                            approverIdTo: res.data.hcCaseDocTransferApprovers[i].approverIdTo,
                            approverToFullname: res.data.hcCaseDocTransferApprovers[i].approverToFullname,
                            approverIdFrom: res.data.hcCaseDocTransferApprovers[i].approverIdFrom,
                            approverFromFullname: res.data.hcCaseDocTransferApprovers[i].approverFromFullname,
                            directionContent: res.data.hcCaseDocTransferApprovers[i].directionContent,
                            isNew: false
                        });
                    }

                    // Danh sách các lãnh đạo đã nhận trình văn bản (đã lọc trùng lắp nếu lãnh đạo được nhận nhiều lần)
                    this.hcCaseDocApprovers = [];
                    let flag = {};
                    for (let i = 0; i < res.data.hcCaseDocApprovers.length; i++) {
                        if (typeof flag[res.data.hcCaseDocApprovers[i].approverId] === 'undefined') {
                            flag[res.data.hcCaseDocApprovers[i].approverId] = true;
                            this.hcCaseDocApprovers.push({
                                id: res.data.hcCaseDocApprovers[i].id,
                                approverFullname: res.data.hcCaseDocApprovers[i].approverFullname,
                                approverId: res.data.hcCaseDocApprovers[i].approverId,
                                positionName: res.data.hcCaseDocApprovers[i].positionName,
                                positionId: res.data.hcCaseDocApprovers[i].positionId
                            });
                        }

                    }

                });
            },

            getListLd() {
                this.leaders = [];
                hanhchinhService.getListLD(this.$store.getters.globalRoles).then(res1 => {
                    res1.data.listLd.forEach(item => {
                        this.leaders.push(item);
                    });
                    hanhchinhService.getListLD(constants.HDTV_DEPT_CODE).then(res2 => {
                        res2.data.listLd.forEach(item => {
                            this.leaders.push(item);
                        });
                    });
                });
            },

            getListDept() {
                hanhchinhService.getDept(this.currentDeptId).then(res => {
                    res.data.departments.forEach(dept => {
                        this.listDept.push({
                            id: dept.id,
                            name: dept.deptName
                        });
                    });
                });
            },

            deptName(deptId) {
                for (let i=0; i<this.listDept.length; i++) {
                    if (deptId == this.listDept[i].id) {
                        return this.listDept[i].name;
                    }
                }
                return "N/A";
            },

            approverName(approverId) {
                for (let i=0; i<this.hcCaseDocApprovers.length; i++) {
                    if (approverId == this.hcCaseDocApprovers[i].approverId) {
                        return this.hcCaseDocApprovers[i].approverFullname;
                    }
                }
                return "N/A";
            },

            formatDate(timestamp) {
                if (timestamp) {
                    return moment(timestamp).format("DD/MM/YYYY");
                }
                return "";
            },

            notifyError(msg) {
                this.notify('Lỗi', msg, 'error', 2000);
            },

            notifySuccess(msg) {
                this.notify('Thông báo', msg, 'success', 2000);
            },
        }
    };
</script>

<style scoped>
  .icon_action {
    font-size: 15px;
    padding: 10px;
  }

  .icon_action:hover {
    background: white;
    box-shadow: 0 8px 15px rgba(39, 124, 190, 0.25);
  }

  .createNew {
    background-color: var(--color-green);
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/luongvanban/luongVb_Detail.vue